<div class="header">
  <div class="header-text">
    <span class="subtitle-02 item-count"
      >{{ selectedItemsCount$ | async }} item(s) selected</span
    >

    <span class="caption attribute-count"
      >{{ attributeIntersectionCount$ | async }} of
      {{ attributeUnionCount$ | async }} attributes</span
    >
  </div>
  <button class="close-button" mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
